<script lang="ts">
import { defineComponent } from 'vue';
import { func, string, bool } from 'vue-types';
import { Popconfirm, Button } from 'ant-design-vue';
import { DeleteOutlined } from '@ant-design/icons-vue';
import type { ButtonType } from 'ant-design-vue/es/button';
import type { SizeType } from 'ant-design-vue/es/config-provider';

export default defineComponent({
  name: 'ConfirmDelete',
  components: {
    Popconfirm,
    Button,
    DeleteOutlined,
  },
  props: {
    onConfirm: func<() => void>().isRequired,
    title: string().def('Are you sure you want to delete?'),
    delText: string(),
    loading: bool().def(false),
    disabled: bool(),
    type: string<ButtonType>().def('dashed'),
    size: string<NonNullable<SizeType>>().def('small'),
    twoTone: {
      default: false,
      type: Boolean,
    },
  },
});
</script>
<template>
  <Popconfirm
    :title="title"
    ok-text="Yes"
    cancel-text="No"
    :disabled="disabled"
    @confirm="onConfirm"
  >
    <Button
      v-if="!twoTone"
      :size="size"
      :type="type"
      :disabled="loading || disabled"
      :loading="loading"
    >
      <template #icon>
        <slot name="icon">
          <DeleteOutlined />
        </slot>
      </template>
      {{ delText }}
    </Button>
    <Button v-else :disabled="loading" :loading="loading">
      <template #icon>
        <DeleteOutlined />
      </template>
      {{ delText }}
    </Button>
  </Popconfirm>
</template>
